<template>
  <NavBar />
  <div v-if="Warteschlange.length > 0" class="offline-banner" role="status">
    <font-awesome-icon icon="fa-solid fa-wifi" />
    Offline – {{ Warteschlange.length }} Änderung{{ Warteschlange.length === 1 ? '' : 'en' }} ausstehend
  </div>
  <main class="content" :class="{ 'content--banner': Warteschlange.length > 0 }">
    <router-view />
  </main>
</template>

<script>
import NavBar from './components/NavBar.vue'
import { SitzungSicherstellen } from './composables/useBenutzer'
import { Warteschlange, OfflineQueueInitialisieren } from './composables/useOfflineQueue'

export default {
  name: 'App',
  components: { NavBar },
  data() {
    return { Warteschlange }
  },
  mounted() {
    SitzungSicherstellen()
    OfflineQueueInitialisieren()
  }
}
</script>

<style>
/* Mobile: schwebende Tab-Bar unten */
.content {
  padding-bottom: calc(var(--nav-height) + 28px);
  min-height: 100vh;
}

/* Tablet+: Sidebar links */
@media (min-width: 768px) {
  .content {
    padding-bottom: 0;
    margin-left: var(--sidebar-width);
    min-height: 100vh;
  }
}

.offline-banner {
  position: fixed;
  top: 12px;
  left: 12px;
  right: 12px;
  z-index: 200;
  background: color-mix(in srgb, var(--color-danger) 88%, transparent);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  border-radius: var(--radius-md);
  color: #fff;
  text-align: center;
  padding: 9px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 6px 20px color-mix(in srgb, var(--color-danger) 35%, transparent);
  animation: SheetHoch 0.3s ease both;
}

.content--banner {
  padding-top: 48px;
}

@media (min-width: 768px) {
  .offline-banner {
    left: calc(var(--sidebar-width) + 16px);
    right: 16px;
    max-width: 480px;
    margin: 0 auto;
  }
}
</style>
